import React from "react";
import { Link } from "react-router-dom";

const LINKS = [
  ["/terms", "Termini"],
  ["/privacy", "Privacy"],
  ["/cookie-policy", "Cookie Policy"],
  ["/contatti", "Contatti"],
  ["/informazioni-societarie", "Informazioni societarie"],
];

export const SiteFooter = () => (
  <div className="mt-auto pt-12 w-full">
  <footer className="bg-slate-100 border-t border-slate-200" data-testid="site-footer">
    <div className="max-w-7xl mx-auto px-6 py-6 text-center text-slate-600 text-xs sm:text-sm">
      <p>© 2026 quandomiserve.it — Tutti i diritti riservati. <span className="whitespace-nowrap" data-testid="site-footer-vat">P. IVA 04565850163</span></p>
      <div className="mt-2 flex flex-wrap justify-center items-center gap-x-3 gap-y-1">
        {LINKS.map(([to, label], i) => (
          <React.Fragment key={to}>
            {i > 0 && <span>|</span>}
            <Link to={to} className="hover:text-orange-600 transition-colors">{label}</Link>
          </React.Fragment>
        ))}
      </div>
    </div>
  </footer>
  </div>
);

export default SiteFooter;
